import { Action } from '@interstate/components/Action';
import * as navigationActionCreators from '@makemydeal/dr-dash-store/actions/navigationActionCreators';
import * as offerActionCreators from '@makemydeal/dr-dash-store/actions/offerActionCreators';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@interstate/components/Typography';
import { ChevronRightIcon } from '@interstate/components/Icons/ChevronRightIcon';
import { useEffect, useState } from 'react';
import { UpdateOfferDialog } from '../../UpdateOfferDialog/UpdateOfferDialog';
import { useValidationGuard } from '../../hooks/useValidationGuard';
import { apiConfigConsts, offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';

const DigitalDealJacketLink = () => {
    const [showSaveOfferForDdj, setShowSaveOfferForDdj] = useState(false);
    const dealRefId = useSelector(offerSelectors.getDealRefId) || offerSessionUtils.getSessionValue(apiConfigConsts.FS_DEAL_REF_ID);
    const [waitForWS, setWaitForWS] = useState(true);
    const [openDdj, setOpenDdj] = useState(false);
    const dispatch = useDispatch();
    const guard = useValidationGuard();
    useEffect(() => {
        if (openDdj && dealRefId) {
            setWaitForWS(false);
            dispatch(navigationActionCreators.navigateToDDJ());
            setOpenDdj(false);
        }
    }, [dealRefId]);
    return (
        <>
            <Typography variant="h3" sx={{ marginBottom: '0px', marginTop: '10px' }}>
                Digital Deal Jacket
            </Typography>
            <Action
                data-testid="digital-deal-jacket-link"
                sx={{ textAlign: 'left' }}
                onClick={guard.wrap(() => {
                    if (!dealRefId) {
                        setOpenDdj(true);
                        dispatch(offerActionCreators.saveOffer());
                        setShowSaveOfferForDdj(true);
                    } else {
                        dispatch(navigationActionCreators.navigateToDDJ());
                    }
                })}
            >
                <Typography variant="anchor-block-sm" color="base.color.blue.700">
                    Manage Documents
                    <ChevronRightIcon fontSize={10} />
                </Typography>
            </Action>
            <UpdateOfferDialog show={showSaveOfferForDdj} onHide={() => setShowSaveOfferForDdj(false)} waitForWS={waitForWS} />
        </>
    );
};

export default DigitalDealJacketLink;
